import type { ContainerProps } from './Container';
import Container from './Container';

import Dots, { type DotsProps } from './Dots';
import Item, { type ItemProps } from './Item';
import Items, { type ItemsProps } from './Items';
import Next, { type NextProps } from './Next';
import Prev, { type PrevProps } from './Prev';
import { useCarousel } from './state';
import ClickableDot, { type ClickableDotProps } from './ClickableDot';

import MultiFrameItem, {
  type MultiFrameItemProps,
} from './multiple-frame-support/Item';
import MultiFrameItems, {
  type MultiFrameItemsProps,
} from './multiple-frame-support/Items';

export const Carousel = {
  Container,
  Dots,
  Item,
  Items,
  Next,
  Prev,
  MultiFrameItem,
  MultiFrameItems,
  ClickableDot,
  useCarousel,
};

export type {
  ContainerProps,
  DotsProps,
  ItemProps,
  ItemsProps,
  NextProps,
  PrevProps,
  MultiFrameItemProps,
  MultiFrameItemsProps,
  ClickableDotProps,
};

export type {
  State as CarouselStateType,
  Type as NavigationType,
} from './state';
